export var MixinPeriods = {
  data: () => ({
    B_PeriodsLoaded: false,
    TO_Periods: [],
    TT_PeriodsList: [],
    L_PeriodsSelected: 0,
    T_PeriodsSelected: ""
  }),
  methods: {
    Fct_PeriodsLoad() {
      if (!this.B_PeriodsLoaded) {
        var T_Token = "JWT " + this.$cookies.get("BackEndToken");
        return this.$BackEndAPI
          .get("budget/distinctperiodyear/", { headers: { Authorization: T_Token } })
          .then(O_Response => {
            if (O_Response.data != "") {
              this.TO_Periods = O_Response.data;
            } else {
              var T_CurrentPeriod = new Date()
                .getFullYear()
                .toString()
                .substr(2, 2); // l'année courante (par ex. 23)
              this.TO_Periods = [{ periode: T_CurrentPeriod }]; // default value
            }
            this.Fct_PeriodsLaunch();
          })
          .catch(() => {
            this.$router.push({ name: "Disconnect" });
          });
      } else {
        // or return a new resolved promise
        return Promise.resolve();
      }
    },
    Fct_PeriodsReLoad() {
      this.B_PeriodsLoaded = false;
      this.Fct_PeriodsLoad();
    },
    Fct_PeriodsLaunch() {
      this.TT_PeriodsList = [];
      for (var L_Index = 0; L_Index < this.TO_Periods.length; L_Index++) {
        var O_Period = this.TO_Periods[L_Index];
        this.TT_PeriodsList.push(O_Period.periode);
      }

      var T_PeriodsList = JSON.stringify(this.TT_PeriodsList);
      this.$cookies.set("PeriodList", T_PeriodsList);

      this.Fct_PeriodsSelect();
      this.B_PeriodsLoaded = true;
    },
    Fct_PeriodsGet() {
      // récupérer la liste depuis le cookie
      this.TT_PeriodsList = [];
      if (this.$cookies.isKey("PeriodList")) {
        this.TT_PeriodsList = JSON.parse(this.$cookies.get("PeriodList"));
      }
      this.Fct_PeriodsSelect();
      this.B_PeriodsLoaded = true;
    },
    Fct_PeriodsSelect() {
      var T_CookiePeriod = "";
      if (this.$cookies.isKey("Period")) {
        T_CookiePeriod = this.$cookies.get("Period");
      }

      var T_CurrentPeriod = new Date()
        .getFullYear()
        .toString()
        .substr(2, 2); // l'année courante (par ex. 23)

      this.L_PeriodsSelected = 0;
      for (var L_Index = 0; L_Index < this.TT_PeriodsList.length; L_Index++) {
        var T_Period = this.TT_PeriodsList[L_Index];
        if (T_Period == T_CurrentPeriod) {
          this.L_PeriodsSelected = L_Index;
        }
        if (T_CookiePeriod != "") {
          if (T_Period == T_CookiePeriod) {
            this.L_PeriodsSelected = L_Index;
            L_Index = this.TT_PeriodsList.length;
          }
        }
      }

      this.T_PeriodsSelected = this.TT_PeriodsList[this.L_PeriodsSelected];
      this.$cookies.set("Period", this.T_PeriodsSelected);
    },
    Fct_PeriodsChange(L_Selected) {
      this.L_PeriodsSelected = L_Selected;
      this.T_PeriodsSelected = this.TT_PeriodsList[this.L_PeriodsSelected];
      this.$cookies.set("Period", this.T_PeriodsSelected);
    }
  }
};
